import React from "react";
import Layout from "../shared/Layout";
import "../dashboard/dashboardcss/dashboard.css";

const journeySteps = [
    { title: "Registration", icon: "fa-user-plus", status: "Completed" },
    { title: "Trials", icon: "fa-person-running", status: "Completed" },
    { title: "Selection", icon: "fa-user-check", status: "Completed" },
    { title: "Player Pool", icon: "fa-users", status: "Completed" },
    { title: "Franchise", icon: "fa-store", status: "Completed" },
    { title: "Auction / Draft", icon: "fa-gavel", status: "Completed" },
    { title: "Team Formation", icon: "fa-people-group", status: "Completed" },
    { title: "Fixtures", icon: "fa-calendar-days", status: "Completed" },
    { title: "Venue", icon: "fa-location-dot", status: "Completed" },
    { title: "Officials", icon: "fa-user-tie", status: "Completed" },
    { title: "Match", icon: "fa-trophy", status: "In Progress" },
    { title: "Live Scoring", icon: "fa-tv", status: "In Progress" },
    { title: "Results", icon: "fa-clipboard-list", status: "In Progress" },
    { title: "Points Table", icon: "fa-chart-column", status: "Upcoming" },
    { title: "Playoffs", icon: "fa-medal", status: "Upcoming" },
    { title: "Final & Awards", icon: "fa-award", status: "Upcoming" },
];

const summaryCards = [
    { label: "Players Registered", value: "12,458", change: "+18.4%", icon: "fa-user", tone: "pink" },
    { label: "Trials Completed", value: "145", change: "+12.7%", icon: "fa-person-running", tone: "amber" },
    { label: "Selected Players", value: "892", change: "+15.3%", icon: "fa-users", tone: "orange" },
    { label: "Teams", value: "48", change: "+6.7%", icon: "fa-people-group", tone: "purple" },
    { label: "Matches Scheduled", value: "216", change: "+10.2%", icon: "fa-calendar-days", tone: "amber" },
    { label: "Live Matches", value: "8", change: "Live", icon: "fa-heart-pulse", tone: "red" },
    { label: "Matches Completed", value: "132", change: "+9.5%", icon: "fa-calendar-check", tone: "green" },
];

const matches = [
    { league: "YCL - T20", teamA: "Jaipur Warriors", teamB: "Delhi Bulls", venue: "SMS Stadium, Jaipur", time: "22 May 2024, 7:00 PM" },
    { league: "YCL - T20", teamA: "Mumbai Strikers", teamB: "Bangalore Blasters", venue: "Wankhede Stadium, Mumbai", time: "23 May 2024, 4:00 PM" },
    { league: "YBL - League", teamA: "Hyderabad Hawks", teamB: "Chennai Chargers", venue: "Indoor Stadium, Hyderabad", time: "24 May 2024, 3:00 PM" },
    { league: "YBL - League", teamA: "Jaipur Smashers", teamB: "Lucknow Lancers", venue: "Sawai Man Singh Indoor, Jaipur", time: "25 May 2024, 6:30 PM" },
];

const points = [
    { team: "Jaipur Warriors", p: 6, w: 5, l: 1, nrr: "+1.256", pts: 10 },
    { team: "Mumbai Strikers", p: 6, w: 4, l: 2, nrr: "+0.689", pts: 8 },
    { team: "Delhi Bulls", p: 6, w: 4, l: 2, nrr: "+0.256", pts: 8 },
    { team: "Bangalore Blasters", p: 6, w: 3, l: 3, nrr: "-0.125", pts: 6 },
    { team: "Hyderabad Hitters", p: 6, w: 2, l: 4, nrr: "-0.589", pts: 4 },
];

const actions = [
    { label: "Add Player", icon: "fa-user-plus" },
    { label: "Add Trial", icon: "fa-file-circle-plus" },
    { label: "Create Match", icon: "fa-sitemap" },
    { label: "Add Venue", icon: "fa-location-dot" },
    { label: "Add News", icon: "fa-newspaper" },
    { label: "Add Sponsor", icon: "fa-handshake" },
    { label: "Create Team", icon: "fa-users-gear" },
    { label: "Live Scoring", icon: "fa-tv" },
    { label: "Send Notification", icon: "fa-bell" },
    { label: "Generate Report", icon: "fa-file-lines" },
];

const analytics = [
    { label: "Revenue", value: "Rs. 8.45 Cr", change: "+22.5%", color: "#26d07c" },
    { label: "Ticket Sales", value: "18,742", change: "+16.8%", color: "#4f8cff" },
    { label: "Website Visitors", value: "256K", change: "+19.6%", color: "#a45cff" },
    { label: "Live Viewers", value: "55K", change: "+23.7%", color: "#ff4f7b" },
];

const revenue = [
    { label: "Sponsorship", percent: "45%", amount: "Rs. 3.80 Cr", color: "#2f7dff" },
    { label: "Ticketing", percent: "25%", amount: "Rs. 2.11 Cr", color: "#25c685" },
    { label: "Franchise Fee", percent: "15%", amount: "Rs. 1.27 Cr", color: "#ffb020" },
    { label: "Merchandise", percent: "8%", amount: "Rs. 0.68 Cr", color: "#ff4f7b" },
    { label: "Other Income", percent: "7%", amount: "Rs. 0.59 Cr", color: "#8f22ff" },
];

const activities = [
    { text: "New player registered - Rohit Sharma (YCL-DEL-2024-0456)", time: "2 min ago" },
    { text: "Trial completed at Jaipur - 120 players evaluated", time: "15 min ago" },
];

const announcements = [
    { text: "YCL T10 Knockout matches start from 25 May 2024", tag: "New", time: "2 hrs ago" },
    { text: "YBL Semi Finals will be played on 28 May 2024", tag: "", time: "5 hrs ago" },
];

const tasks = [
    { text: "Approve 45 pending trial results", priority: "High", due: "Due in 2 hrs" },
    { text: "Finalize auction player list", priority: "Medium", due: "Due in 5 hrs" },
];

const MiniChart = ({ color }) => (
    <div className="dash-mini-chart" style={{ "--chart-color": color }}>
        <span style={{ height: "28%" }} />
        <span style={{ height: "50%" }} />
        <span style={{ height: "42%" }} />
        <span style={{ height: "66%" }} />
        <span style={{ height: "58%" }} />
        <span style={{ height: "84%" }} />
    </div>
);

const Dashboard = () => {
    return (
        <Layout>
            <div className="league-dashboard right-content-section">
                <section className="dash-topbar">
                    <div>
                        <h1>Yuva Sports League Management System</h1>
                        <p>YCL (Cricket) + YBL (Badminton)</p>
                    </div>
                    <div className="dash-filters">
                        <select defaultValue="2024-25">
                            <option value="2024-25">Season 2024-25</option>
                        </select>
                        <select defaultValue="all">
                            <option value="all">All Leagues</option>
                        </select>
                        <button><i className="fa-solid fa-calendar-days" /></button>
                        <button><i className="fa-solid fa-bell" /><span>12</span></button>
                    </div>
                </section>

                <section className="dash-panel league-journey">
                    <div className="dash-section-title">
                        <h2>League Journey</h2>
                        <button>View Full Journey</button>
                    </div>
                    <div className="journey-track">
                        {journeySteps.map((step, index) => (
                            <div className="journey-step" key={step.title}>
                                <div className={`journey-icon ${step.status.replace(" ", "-").toLowerCase()}`}>
                                    <i className={`fa-solid ${step.icon}`} />
                                </div>
                                {index < journeySteps.length - 1 && <span className="journey-arrow">-&gt;</span>}
                                <strong>{index + 1}</strong>
                                <p>{step.title}</p>
                                <small>{step.status}</small>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="summary-grid">
                    {summaryCards.map((card) => (
                        <article className="dash-card summary-card" key={card.label}>
                            <div className={`summary-icon ${card.tone}`}>
                                <i className={`fa-solid ${card.icon}`} />
                            </div>
                            <div>
                                <p>{card.label}</p>
                                <h3>{card.value}</h3>
                                <small>{card.change} This Season</small>
                            </div>
                        </article>
                    ))}
                </section>

                <section className="dashboard-main-grid">
                    <article className="dash-card upcoming-card">
                        <div className="dash-section-title">
                            <h2>Upcoming Matches</h2>
                            <button>View All</button>
                        </div>
                        {matches.map((match) => (
                            <div className="match-row" key={`${match.teamA}-${match.teamB}`}>
                                <span>{match.league}</span>
                                <div className="match-teams">
                                    <strong>{match.teamA}</strong>
                                    <b>VS</b>
                                    <strong>{match.teamB}</strong>
                                </div>
                                <p>{match.time}</p>
                                <small>{match.venue}</small>
                            </div>
                        ))}
                    </article>

                    <article className="dash-card live-score-card">
                        <div className="dash-section-title">
                            <h2>Live Score - YCL (Cricket)</h2>
                            <button>View All</button>
                        </div>
                        <div className="live-tag"><span /> Live - YCL - T10 Match</div>
                        <div className="score-versus">
                            <div><i className="fa-solid fa-shield-halved" />Jaipur Warriors</div>
                            <h3>128/4 <small>(12.3 Overs)</small></h3>
                            <div><i className="fa-solid fa-shield-halved" />Delhi Bulls</div>
                        </div>
                        <p className="score-note">Delhi Bulls won the toss and elected to field</p>
                        <table className="score-table">
                            <tbody>
                                <tr><td>Arjun Mehta</td><td>45</td><td>K. Verma</td><td>2/23</td></tr>
                                <tr><td>Rahul Sharma</td><td>32</td><td>A. Khan</td><td>3/30</td></tr>
                            </tbody>
                        </table>
                        <button className="full-width-btn">View Full Scorecard</button>
                    </article>

                    <article className="dash-card live-score-card badminton">
                        <div className="dash-section-title">
                            <h2>Live Score - YBL (Badminton)</h2>
                            <button>View All</button>
                        </div>
                        <div className="live-tag"><span /> Live - Men's Singles</div>
                        <div className="badminton-score">
                            <div><i className="fa-solid fa-user" /><strong>Lakshya Sen</strong></div>
                            <h3>21 - 18 <small>Game 2</small></h3>
                            <div><i className="fa-solid fa-user" /><strong>K. Nishimoto</strong></div>
                        </div>
                        <table className="score-table">
                            <thead><tr><th>Game</th><th>1</th><th>2</th><th>3</th></tr></thead>
                            <tbody>
                                <tr><td>Lakshya Sen</td><td>21</td><td>21</td><td>-</td></tr>
                                <tr><td>K. Nishimoto</td><td>17</td><td>18</td><td>-</td></tr>
                            </tbody>
                        </table>
                        <p className="score-note">Match Time: 36m</p>
                        <button className="full-width-btn magenta">View Full Match</button>
                    </article>

                    <article className="dash-card points-card">
                        <div className="dash-section-title">
                            <h2>Points Table - YCL</h2>
                            <button>View Full Table</button>
                        </div>
                        <table>
                            <thead>
                                <tr><th>Pos</th><th>Team</th><th>P</th><th>W</th><th>L</th><th>NRR</th><th>Pts</th></tr>
                            </thead>
                            <tbody>
                                {points.map((team, index) => (
                                    <tr key={team.team}>
                                        <td>{index + 1}</td>
                                        <td>{team.team}</td>
                                        <td>{team.p}</td>
                                        <td>{team.w}</td>
                                        <td>{team.l}</td>
                                        <td>{team.nrr}</td>
                                        <td>{team.pts}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </article>
                </section>

                <section className="dashboard-lower-grid">
                    <article className="dash-card quick-actions">
                        <div className="dash-section-title"><h2>Quick Actions</h2></div>
                        <div>
                            {actions.map((action) => (
                                <button key={action.label}>
                                    <i className={`fa-solid ${action.icon}`} />
                                    {action.label}
                                </button>
                            ))}
                        </div>
                    </article>

                    <article className="dash-card analytics-card">
                        <div className="dash-section-title">
                            <h2>Analytics Overview</h2>
                            <button>View All</button>
                        </div>
                        <div className="analytics-grid">
                            {analytics.map((item) => (
                                <div className="analytics-tile" key={item.label}>
                                    <p>{item.label}</p>
                                    <h3>{item.value}</h3>
                                    <small>{item.change}</small>
                                    <MiniChart color={item.color} />
                                </div>
                            ))}
                        </div>
                    </article>

                    <article className="dash-card revenue-card">
                        <div className="dash-section-title">
                            <h2>Revenue Overview</h2>
                            <button>View Details</button>
                        </div>
                        <div className="revenue-content">
                            <div className="revenue-donut">
                                <strong>Rs. 8.45 Cr</strong>
                                <span>Total Revenue</span>
                            </div>
                            <div className="revenue-list">
                                {revenue.map((item) => (
                                    <div key={item.label}>
                                        <span style={{ background: item.color }} />
                                        <p>{item.label}</p>
                                        <strong>{item.percent}</strong>
                                        <small>{item.amount}</small>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </article>
                </section>

                <section className="dashboard-bottom-grid">
                    <article className="dash-card feed-card">
                        <div className="dash-section-title"><h2>Recent Activities</h2><button>View All</button></div>
                        {activities.map((item) => (
                            <div className="feed-row" key={item.text}>
                                <i className="fa-solid fa-circle-info" />
                                <p>{item.text}</p>
                                <small>{item.time}</small>
                            </div>
                        ))}
                    </article>
                    <article className="dash-card feed-card">
                        <div className="dash-section-title"><h2>Announcements</h2><button>View All</button></div>
                        {announcements.map((item) => (
                            <div className="feed-row" key={item.text}>
                                <i className="fa-solid fa-bullhorn" />
                                <p>{item.text}</p>
                                {item.tag && <span>{item.tag}</span>}
                                <small>{item.time}</small>
                            </div>
                        ))}
                    </article>
                    <article className="dash-card feed-card task-card">
                        <div className="dash-section-title"><h2>Tasks & Reminders</h2><button>View All</button></div>
                        {tasks.map((item) => (
                            <div className="feed-row" key={item.text}>
                                <input type="checkbox" />
                                <p>{item.text}</p>
                                <span className={item.priority.toLowerCase()}>{item.priority}</span>
                                <small>{item.due}</small>
                            </div>
                        ))}
                    </article>
                </section>
            </div>
        </Layout>
    );
};

export default Dashboard;
